import React, { useState } from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "./auth/AuthProvider";
import {Card, CardBody, CardFooter, CardHeader, Spacer, Divider, Image, Input, Button, Form, Alert} from "@heroui/react";
import axios from 'axios';

function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const { login } = useAuth(); // Usando el método login del contexto

    const handleSubmit = async (e) => {
        setError("")
        e.preventDefault();

        const credentials = btoa(`${username}:${password}`); // Base64 encoding

        try {
            // Crear una instancia de axios que use la configuración de apiClient pero sin interceptors
            const loginClient = axios.create({
                baseURL: process.env.REACT_APP_API_URL,
                timeout: 10000,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${credentials}`,
                }
            });

            const response = await loginClient.post('/auth/boxauth');

            const authToken = response.headers["auth-token"];
            if (!authToken) {
                throw new Error("Token no encontrado en los encabezados");
            }

            const data = response.data; //el body en json
            console.log("dataLogin:", data);
            if(data.exporter_login){
                localStorage.setItem("exporterAuthToken", authToken);
            }
            //console.log("Login exitoso:", authToken);
            login(authToken);
            navigate("/"); // Cambia al destino que quieras
        } catch (err) {
            console.error("Error en login:", err);
            if (err.response?.status === 401) {
                setError("Credenciales inválidas");
            } else if (err.response?.status >= 500) {
                setError("Error en el servidor. Intenta nuevamente.");
            } else {
                setError(err.message || "Error al iniciar sesión");
            }
        }
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh", // Ocupa toda la altura de la ventana
                backgroundColor: "#f5f5f5", // Color de fondo opcional
            }}
        >
            <Card className="max-w-[400px]">
                <CardHeader className="flex gap-3 justify-center items-center">
                    <Image
                        alt="QuickView Logo"
                        className="max-w-[240px] max-h-[40px] object-contain"
                        height={40}
                        radius="sm"
                        src= {process.env.PUBLIC_URL + "/QuickViewR.png"}
                        width={270}
                    />
                    <Image
                        src= {process.env.PUBLIC_URL + "/PoweredBy.png"}
                        className="max-w-[70px] max-h-[40px] object-contain"
                        width={70}
                        height={40}
                        alt="AWS Logo"
                    />
                </CardHeader>
                <Divider />
                <Form
                    validationBehavior="native"
                    onSubmit={ handleSubmit }
                >
                    <CardBody>
                        <Input
                            isRequired
                            className="max-w-xs"
                            label="Usuario"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                        <Spacer className="h-2" />
                        <Input
                            isRequired
                            className="max-w-xs"
                            label="Contraseña"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <Spacer className="h-3"/>
                        <div className="flex justify-center">
                            {error && <Alert className="max-w-[250px]" color="danger">{error}</Alert>}
                        </div>
                    </CardBody>
                    <Divider />
                    <CardFooter className="justify-end">
                        <Button color="primary" type="submit">
                            Iniciar Sesión
                        </Button>
                    </CardFooter>
                </Form>
            </Card>
        </div>
    );
}

export default Login;
